import leadApi from '@src/features/leads/services/lead-api';
import {
  EditableInputCell,
  EditableInputCellViewMode,
  EditableInputCellEditMode,
} from '@src/shared/components/editable-input-cell';

import type { TLead } from '@src/shared/types/lead';

export function LeadEmailCell({ lead }: { lead: TLead }) {
  const { mutate: updateLead, variables, error } = leadApi.useUpdate();

  const displayValue = error
    ? lead.email
    : variables?.email || lead.email || '-';

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (e.target.value.trim() === displayValue?.trim()) return;
    updateLead({
      id: lead.id,
      email: e.target.value,
    });
  };

  return (
    <EditableInputCell copyToText={lead.email}>
      <EditableInputCellViewMode>{displayValue}</EditableInputCellViewMode>
      <EditableInputCellEditMode
        value={displayValue}
        onBlur={handleBlur}
      />
    </EditableInputCell>
  );
}
